module.exports = __webpack_public_path__ + "media/images/web_suite/dashboard/community_support_icon-215f47330f03ca9d9ccd5c5d3de03dde.png";